export default {
    meta: {
        app: {
            title: "OPQ | Ordre des psychologues du Québec",
        },
        formulaires: {
            title: "Formulaire | Ordre des psychologues du Québec",
            creationDeCompte: {
                title: "Création de compte | Ordre des psychologues du Québec"
            }
        },
        repertoire: {
            title: "OPQ | Répertoire"
        }
    },
    formulaires: {
        chargement: "Chargement...",
        envoiDesInformations: "Envoi des informations...",
        suivant: "Suivant",
        provinceEtCategorieIncompatibles: 'La province sélectionnée et la catégorie de membre sont incompatibles.',
        deuxChoixMaximum: "2 choix maximum"
    },
    addressComplete: {
        description: "Pour vérifier l'adresse, attendre le chargement de l'adresse et ensuite sélectionner la bonne adresse. Les champs de la fiche vont ensuite se renseigner automatiquement en fonction de l'adresse sélectionnée. Sinon, fermer la fenêtre."
    }
}